<template>
  <el-dialog title="产能提示" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false" @close="$emit('cancel')">
    <div class="cap-preview">
      <!-- 非工作日：那天无产能安排（引擎只排工作日）·不做超产能判定 -->
      <p class="tip" v-if="!judgeIsWorkday">
        所选交付日<template v-if="judgeDay">【{{judgeDay}}】</template>为<b>非工作日</b>，当天无产能安排，系统将自动排到最近工作日<template v-if="recommendDate">（推荐交付日 <b>{{recommendDate}}</b>）</template>。是否仍按所填期望日提交？
      </p>
      <p class="tip" v-else>
        当前<template v-if="categoryGroupName">【{{categoryGroupName}}】</template>产能{{worstSignal === 'red' ? '已满' : '紧张'}}，请确认是否仍按所填期望日提交。
      </p>
      <!-- 本单产能判定（脱敏·下单人看·只占用百分比·不展示产能/已排绝对数字）·非工作日不展示 -->
      <div class="judge" v-if="judgeDay && judgeIsWorkday">
        <div class="judge-row">判定日（最早期望交付日）：<b>{{judgeDay}}</b>
          <span class="pct" :class="worstSignal==='red'?'over':'tight'">占用 {{Math.round(judgeRatio*100)}}%</span>
        </div>
      </div>
      <div class="water-bar" v-if="waterList.length">
        <div class="water-tit">近 {{waterList.length}} 个工作日水位（占用百分比）：</div>
        <el-tooltip v-for="(w, i) in waterList" :key="i" placement="top"
          :content="w.date + '  占用 ' + Math.round((w.ratio || 0) * 100) + '%'">
          <span class="sig" :class="sigClass(w.signal)">{{w.date.slice(5)}} {{Math.round((w.ratio || 0) * 100)}}%</span>
        </el-tooltip>
      </div>
      <p class="rec" v-if="recommendDate && judgeIsWorkday">推荐交付日（仅参考）：<b>{{recommendDate}}</b><span v-if="worstSignal === 'yellow'">，建议改到该日以错峰。</span></p>
      <!-- 纯提醒：不拦截下单、不收原因、不转审批（超产能审批 2026-07-10 已下线，本弹框 2026-08-03 只恢复提醒） -->
      <p class="apply" v-if="worstSignal === 'red'">超出当日产能<b>不拦截下单</b>，可直接提交；系统会按排单规则安排制作组与实际交付日，实际交付可能晚于所填期望日。</p>
    </div>
    <span slot="footer">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="$emit('confirm')">仍要提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CapacityPreviewModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    waterList: {
      type: Array,
      default: function() { return [] }
    },
    recommendDate: {
      type: String,
      default: ''
    },
    worstSignal: {
      type: String,
      default: 'green'
    },
    categoryGroupName: {
      type: String,
      default: ''
    },
    judgeDay: {
      type: String,
      default: ''
    },
    judgeIsWorkday: {
      type: Boolean,
      default: true
    },
    demand: {
      type: Number,
      default: 0
    },
    judgeRatio: {
      type: Number,
      default: 0
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { if (!val) this.$emit('cancel') }
    }
  },
  methods: {
    sigClass(s) {
      return { green: 'ample', yellow: 'tight', red: 'short' }[s] || 'ample'
    }
  }
}
</script>

<style lang="scss" scoped>
.cap-preview {
  .tip {
    font-size: 14px;
    margin-bottom: 12px;
    color: #303133;
  }
  .judge {
    margin: 10px 0;
    padding: 10px 12px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    font-size: 13px;
    color: #606266;
    line-height: 1.9;
  }
  .judge b { color: #303133; }
  .judge b.over { color: #f56c6c; }
  .judge b.tight { color: #e6a23c; }
  .judge .pct {
    margin-left: 8px;
    padding: 1px 8px;
    border-radius: 10px;
    font-weight: 600;
  }
  .judge .pct.over { background: #fef0f0; color: #f56c6c; }
  .judge .pct.tight { background: #fdf6ec; color: #e6a23c; }
  .water-tit {
    width: 100%;
    font-size: 12px;
    color: #909399;
    margin-bottom: 2px;
  }
  .water-bar {
    margin: 10px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
  .sig {
    display: inline-block;
    margin: 2px 4px 2px 0;
    padding: 1px 9px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    cursor: default;
  }
  .sig.ample { background: #f0f9eb; color: #67c23a; }
  .sig.tight { background: #fdf6ec; color: #e6a23c; }
  .sig.short { background: #fef0f0; color: #f56c6c; }
  .rec {
    margin-top: 12px;
    font-size: 13px;
    color: #606266;
  }
  .apply {
    margin-top: 10px;
    font-size: 13px;
    color: #606266;
  }
  .apply b { color: #303133; }
}
</style>
